module.exports = __webpack_public_path__ + "img/map.190b9a5c.png";